"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const api_external_contract_js_1 = require("@tableau/api-external-contract-js");
const TableauError_1 = require("../TableauError");
if (typeof window !== 'undefined') {
    window.__tableauApiServiceRegistry = window.__tableauApiServiceRegistry || {};
}
class ServiceRegistryImpl {
    constructor() {
        this._services = {};
    }
    registerService(service) {
        this._services[service.serviceName] = service;
    }
    getService(serviceName) {
        if (!this._services.hasOwnProperty(serviceName)) {
            throw new TableauError_1.TableauError(api_external_contract_js_1.ErrorCodes.InternalError, `Service not registered: ${serviceName}`);
        }
        return this._services[serviceName];
    }
}
/**
 * Static class used for getting access to the single instance
 * of the ApiServiceRegistry associated with the registryId.
 *
 * Extensions by design don't need to store/access multiple service registries. Their single instance of ServiceRegistry is
 * stored/access with registryId = 0.
 *
 * Whereas Embedding needs to be aware of which ServiceRegistry to use when there are multiple vizzes embedded.
 * An example of how window.__tableauApiServiceRegistry will look when there are two vizzes: { 0 : ServiceRegistry, 1 : ServiceRegistry}
 * where registry ID of 0 & 1 refers to viz's internal identifier (which is generated by VizManager).
 */
class ApiServiceRegistry {
    /**
     * Gets the singleton instance of the ServiceRegistry
     */
    static get(registryId) {
        if (!window.__tableauApiServiceRegistry || !window.__tableauApiServiceRegistry[registryId]) {
            ApiServiceRegistry.setInstance(registryId, new ServiceRegistryImpl());
        }
        if (!window.__tableauApiServiceRegistry[registryId]) {
            throw new TableauError_1.TableauError(api_external_contract_js_1.ErrorCodes.InternalError, 'Service registry failed');
        }
        return window.__tableauApiServiceRegistry[registryId];
    }
    /**
     * Helper method that sets the service registry instance for the corresponding registryId. Can be used by unit tests
     *
     * @param {ServiceRegistry} serviceRegistry The new registry
     */
    static setInstance(registryId, serviceRegistry) {
        if (!window.__tableauApiServiceRegistry) {
            window.__tableauApiServiceRegistry = {};
        }
        window.__tableauApiServiceRegistry[registryId] = serviceRegistry;
    }
    /**
     * Only used by unit tests
     */
    static clearRegistry() {
        window.__tableauApiServiceRegistry = {};
    }
    // Private to avoid anyone constructing this
    constructor() { }
}
exports.ApiServiceRegistry = ApiServiceRegistry;
//# sourceMappingURL=ServiceRegistry.js.map